module.exports = __webpack_public_path__ + "img/curly-logo-dark.015b4670.svg";